import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getIcons, userRole } from '../Constant/Constant';
import AdminAppBar from '../adminComponents/AdminAppBar';

const SetupNavigationManager = () => {
  const icons = getIcons();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);

  const setupMenuList = [
    {
      name: 'Sales Teams',
      icon: icons?.teamsIcon,
      navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/sale-team`,
    },
    {
      name: 'Users',
      icon: icons?.usersIcon,
      navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/users`,
    },
    // {
    //   name: 'CP Management',
    //   icon: icons?.CpManageIcon,
    //   navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/cp-management`,
    // },
    {
      name: 'Properties',
      icon: icons?.PropertiesIcons,
      navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/properties-list`,
    },
    {
      name: 'Property Inventory',
      icon: icons?.PropertyInventoryIcon,
      navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/property-inventory`,
    },
    {
      name: 'Interest & Source',
      icon: icons?.ImterestSourceIcon,
      navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/interest-sources`,
    },
    // {
    //   name: 'Integration',
    //   icon: icons?.IntegrationIcons,
    //   navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/web-hooks`,
    // },
    // {
    //   name: 'Custom API',
    //   icon: icons?.APIIcons,
    //   navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/custom-api`,
    // },
    // {
    //   name: 'Incentives',
    //   icon: icons?.IncentivesIcons,
    //   navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/web-hooks`,
    // },
    // {
    //     name: 'Automated Message',
    //     navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/auto-message`,
    //     icon: icons?.AutoMsgIcon,
    //   },
    // {
    //   name: 'Marketing Hub',
    //   icon: icons?.MarketingHubIcon,
    //   subMenu: [
    //     {
    //       name: 'Content Hub',
    //       navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/marketing-hub`,
    //       icon: icons?.ContentHubIcon,
    //     },
    //     {
    //       name: 'Spin Wheel',
    //       navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/spin-wheel`,
    //       icon: icons?.SpinWeelIcon,
    //     },
        
    //     {
    //       name: 'GL Pages',
    //       navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/gl-pages`,
    //       icon: icons?.glPageIcon,
    //     },
        
    //   ],
    // },
    // {
    //   name: 'My Profile',
    //   icon: icons?.activityProgress,
    //   navigator: `/${userRole === 'Admin' ? 'admin' : 'cmo'}/my-profile`,
    // },
    // {
    //   name: 'Sign Out',
    //   icon: icons?.setupIconActive,
    //   navigator: '/sign-out',
    // },
  ];

  const handleCardClick = (item) => {
    if (item.subMenu) {
      setSelectedMenuItem(item);
      setIsModalOpen(true);
    } else if (item.navigator) {
      navigate(item.navigator);
    }
  };

  const handleSubMenuClick = (navigator) => {
    navigate(navigator);
    setIsModalOpen(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMenuItem(null);
  };

  return (
    <div className="bg-gray-100 min-h-screen pb-16">
      <AdminAppBar />
      <div className="pt-24 px-6 ">
        {/* Heading */}
        <div className="my-7">
          <h1 className="text-3xl font-medium text-gray-800">Setup</h1>
        
        </div>

        {/* Setup Menu Cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
          {setupMenuList.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-[10px] p-2 group shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 cursor-pointer overflow-hidden"
              onClick={() => handleCardClick(item)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && handleCardClick(item)}
            >
              <div className="flex flex-col items-center py-6 px-3">
                <div className="w-16 h-16 bg-green-50 p-3 group-hover:bg-green-100 flex items-center justify-center mb-2 rounded-full ">
                  <img
                    src={item.icon}
                    alt={`${item.name} icon`}
                    className="w-14 h-14 object-contain"
                  />
                </div>
                <span className="text-sm font-medium text-gray-800 text-center">
                  {item.name}
                </span>
                {item.subMenu && (
                  <div className="mt-[95px] absolute text-customGreen ">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Improved Modal sub-menu */}
      {isModalOpen && selectedMenuItem && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 transition-opacity duration-300">
          <div 
            className="bg-white rounded-[10px] p-4  shadow-lg w-full max-w-3xl m-4 transform transition-transform duration-300"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between bg-gray-100 px-4 py-4 rounded-[10px] border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="bg-white p-2 rounded-full shadow-sm">
                  <img 
                    src={selectedMenuItem.icon} 
                    alt={selectedMenuItem.name} 
                    className="w-8 h-8"
                  />
                </div>
                <h3 className="text-xl font-medium text-customGreen">
                  {selectedMenuItem.name}
                </h3>
              </div>
              <button
                onClick={closeModal}
                className="text-red-500  bg-white rounded-full p-2 transition-colors duration-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {selectedMenuItem.subMenu.map((subItem, subIndex) => (
                  <div
                    key={subIndex}
                    className="flex flex-col items-center bg-white border border-gray-100 shadow-sm hover:shadow rounded-xl p-6 cursor-pointer transition-all duration-200 hover:border-green-200 group"
                    onClick={() => handleSubMenuClick(subItem.navigator)}
                    role="menuitem"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubMenuClick(subItem.navigator)}
                  >
                    <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mb-4 group-hover:bg-green-100 transition-colors duration-200">
                      <img
                        src={subItem.icon}
                        alt={`${subItem.name} icon`}
                        className="w-8 h-8 object-contain"
                      />
                    </div>
                    <span className="text-base font-medium text-gray-800 text-center">
                      {subItem.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetupNavigationManager;